import {svgIconWrapper} from '../svg-icon-wrapper';

import XeroRegular from './xero-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <XeroRegular {...props} />;
}

SvgComponent.iconName = 'xeroRegular';

export const XeroRegularIcon = svgIconWrapper(SvgComponent);
